import React, { useState, useEffect, useRef } from "react";
import { ImageConstants } from "../../../assets/img/ImageConstants";

const Banner = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const timeoutRef = useRef(null);

  const images = [
    ImageConstants.polanibanner4,
    ImageConstants.polanibanner5,
    ImageConstants.homeBanner1,
    ImageConstants.homeBanner2,
  ];

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => resetTimeout();
  }, [activeIndex]);

  const goToSlide = (index) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setActiveIndex(index);
    setTimeout(() => setIsTransitioning(false), 500);
  };

  const goToPrevious = () => {
    const newIndex = activeIndex === 0 ? images.length - 1 : activeIndex - 1;
    goToSlide(newIndex);
  };

  const goToNext = () => {
    const newIndex = (activeIndex + 1) % images.length;
    goToSlide(newIndex);
  };

  return (
    <section
      className="banner-container"
      style={{ height: "100vh", position: "relative", overflow: "hidden" }}
    >
      {images.map((imgSrc, index) => (
        <div
          key={index}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `url(${imgSrc})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: index === activeIndex ? 1 : 0,
            transition: "opacity 0.5s ease-in-out",
            zIndex: index === activeIndex ? 1 : 0,
          }}
        />
      ))}

      <div className="container" style={{ position: "relative", zIndex: 2 }}>
        <div className="row align-items-center" style={{ height: "100vh" }}>
          <div className="col-lg-12">
            <div
              className="banner_one_text"
              style={{ textAlign: "center", color: "#fff" }}
            >
              <h1 className="fs-1">Explore the World with House of Polani</h1>
              <h3 className="fw-normal">
                Your Trusted Travel Partner Since 1973
              </h3>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Dots */}
      <div
        style={{
          position: "absolute",
          bottom: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: "10px",
          zIndex: 2,
        }}
      >
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            style={{
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              border: "none",
              background:
                index === activeIndex ? "#fff" : "rgba(255, 255, 255, 0.5)",
              cursor: "pointer",
              padding: 0,
            }}
          />
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={goToPrevious}
        style={{
          position: "absolute",
          left: "20px",
          top: "50%",
          transform: "translateY(-50%)",
          background: "rgba(0, 0, 0, 0.5)",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          zIndex: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        &#10094;
      </button>

      <button
        onClick={goToNext}
        style={{
          position: "absolute",
          right: "20px",
          top: "50%",
          transform: "translateY(-50%)",
          background: "rgba(0, 0, 0, 0.5)",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          zIndex: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        &#10095;
      </button>
    </section>
  );
};

export default Banner;
